import React, { useState, useEffect, useReducer } from "react";
import _, { max } from "lodash";
import { Link, useParams } from "react-router-dom";
import ScrollView from "devextreme-react/scroll-view";
import SelectBox from "../common/selectBox/SelectBox";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { postUserLog } from "../../actions/common";
import * as utils from "../../common/utils";
import * as actions from "../../actions/siteDetails";
import siteReducer from "../../reducers/siteDetails";

const initialState = {
  siteLocations: [],
  tiers: [],
  userData: {},
  pinSiteStatus: null,
  pinnedSites: [],
  siteHighestTier: null,
};

const Tiers = () => {
  const appsTxt = {
    digital: "Digital Tier",
    standardWork: "Standard work",
    settings: "Settings",
  };
  const cardShapes = { Tier: "hexagon", gbe: "gbe" };

  const { category, app, site } = useParams();
  const [state, dispatch] = useReducer(siteReducer, initialState);
  const { siteLocations, pinnedSites, siteHighestTier } = state;
  const [animate, setAnimate] = useState("");
  const [activeTier, setActiveTier] = useState("");
  const [searchTxt, setSearchTxt] = useState("");
  const [tierList, setTierList] = useState([]);

  const handleGenerateTierList = () => {
    let _tierList = utils.SITE_TIER_LIST.filter(
      (ele) => ele.id === "" || parseInt(ele.id) <= siteHighestTier
    );
    setTierList([..._tierList]);
  };

  const handleTierChange = (val) => {
    setActiveTier(val.id);
    postUserLog({
      event: "Select Tier",
      data: {
        action: val.label + " selected",
        module: "Tier Screen",
        section: "Select Tier",
        siteUId: site,
        widget: "",
      },
    });
  };

  const scrollConfig = {
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  };

  useEffect(() => {
    handleGenerateTierList();
  }, [siteHighestTier]);

  useEffect(() => {
    actions.fetchSiteHighestTier(dispatch, site);
    actions.fetchTiers(dispatch, site);
    actions.fetchSiteLocations(dispatch, category);
    actions.fetchPinnedSites(dispatch, category);
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  const updatePinSite = () => {
    let site = getSitInfo();
    let isPinned = site.isPinned ? false : true;
    let pinStatus = isPinned ? "pinned" : "unpinned";
    actions.updatePinSite(
      dispatch,
      `siteid=${site.siteId}&pinned=${isPinned}`,
      category
    );
    postUserLog({
      event: "Pin/UnPin Site",
      data: {
        action: site.siteName + " site " + pinStatus,
        module: "Tier Screen",
        section: "Header",
        siteUId: site,
        widget: "",
      },
    });
  };
  const getSitInfo = () => {
    let data = _.find(siteLocations, ["siteId", site]);
    return data;
  };

  const getSiteName = () => {
    let data = getSitInfo();
    return data ? data.siteName : "";
  };

  const getTiers = (blockTier) => {
    let tiers = state.tiers;
    if (activeTier) {
      tiers = state.tiers.filter((data, i) => {
        if (data.tierLevel === activeTier) {
          return data;
        }
      });
    } else {
      tiers = state.tiers.filter((data, i) => {
        if (data.tierLevel === blockTier.id) {
          return data;
        }
      });
    }

    if (searchTxt) {
      tiers = _.filter(tiers, (data) =>
        data.name.toLowerCase().includes(searchTxt)
      );
      postUserLog({
        event: "Search Tier",
        data: {
          action: "Searched for " + searchTxt,
          module: "Tier Screen",
          section: "Search Tier",
          siteUId: site,
          widget: "",
        },
      });
    }

    return tiers.map((data, i) => (
      <Link
        to={`/dashboard/${category}/${site}/${data.id}`}
        style={{ margin: "10px" }}
        key={i}
        onClick={() =>
          postUserLog({
            event: "Tier Selection",
            data: {
              action: data.name + " selected",
              module: "Tier Screen",
              section: "Tier Level Selection",
              siteUId: site,
              widget: "",
            },
          })
        }
      >
        <div key={i} className={"app " + cardShapes[data.type]}>
          <span className="shape">{data.tierLevel}</span>
          <span className="label">{data.name}</span>
        </div>
      </Link>
    ));
  };
  return (
    <>
      <Header showPinBtn={updatePinSite} site={getSitInfo()} />

      <section className="page-content">
        <div className="site-view tier-wrap">
          <div className={"site-list " + animate}>
            <div className="breadcrumb">
              <span
                className={"icon icon-" + utils.getSbgName(category)}
              ></span>
              <ul>
                <li>
                  <Link
                    to={`/home/${category}`}
                    onClick={() => {
                      postUserLog({
                        event: "SBG Clicked",
                        data: {
                          action:
                            "Navigates to " +
                            utils.getSbgNameTxt(category) +
                            " Site Selection Screen",
                          module: "Tier Screen",
                          section: "BreadCrumb",
                          siteUId: site,
                          widget: "",
                        },
                      });
                    }}
                  >
                    {utils.getSbgNameTxt(category)}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/sitehome/${category}/${site}`}
                    onClick={() => {
                      postUserLog({
                        event: "Site Clicked",
                        data: {
                          action:
                            "Navigates to " +
                            getSiteName() +
                            " Site Home Screen",
                          module: "Tier Screen",
                          section: "BreadCrumb",
                          siteUId: site,
                          widget: "",
                        },
                      });
                    }}
                  >
                    {getSiteName()}
                  </Link>
                </li>

                <li>{appsTxt[app]}</li>
              </ul>
            </div>
            <div className="site-head">
              <div className="page-heading">
                <h2>
                  <span className={"icon " + app}></span> {appsTxt[app]}
                </h2>
              </div>

              <div className="select-tier">
                <div className="dx-field">
                  <div className="dx-field-value">
                    <SelectBox
                      items={tierList}
                      value={activeTier}
                      handleChange={handleTierChange}
                    />
                  </div>
                </div>
              </div>
              <div className="search">
                <div className="form-group">
                  <input
                    type="text"
                    placeholder="Search Tiers"
                    value={searchTxt}
                    onChange={(e) => setSearchTxt(e.target.value)}
                  />
                  <span className="icon search-icon"></span>
                </div>
              </div>
            </div>

            <div className="site-body scroll tier-list">
              <ScrollView id="tierApps" {...scrollConfig}>
                <div className="site-body">
                  {!activeTier ? (
                    <>
                      {[...new Array(tierList.length)].map((tier, idx) => {
                        if (idx > 0 && getTiers(tierList[idx]).length > 0) {
                          return (
                            <React.Fragment key={`tier-${idx}`}>
                              <h3 style={{ "text-wrap": "nowrap" }}>
                                {tierList[idx].label}
                              </h3>
                              <div class="tier-block">
                                <div></div>
                                <div class="tier-detail">
                                  {getTiers(tierList[idx])}
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        }
                      })}
                    </>
                  ) : (
                    <>
                      <div>
                        <h4>Tier {activeTier}</h4>
                      </div>
                      <div class="tier-detail">{getTiers()}</div>
                    </>
                  )}
                </div>
              </ScrollView>
            </div>
          </div>
        </div>
      </section>

      <Footer
        showThemeSwitch={true}
        hideSiteCount={true}
        activeSites={pinnedSites}
        sbg={category}
      />
    </>
  );
};
export default Tiers;
